import { useSelector } from 'react-redux';

import { Title } from '../../components/Title';
import { getObjectInfo } from '../../selectors/objectInfo';

export function TitleContainer() {
  const { objectName, objectUrl } = useSelector(getObjectInfo);
  const objectPrefix = 'Отзывы и вопросы о ';

  return <Title objectPrefix={objectPrefix} objectTitle={objectName} objectLink={objectUrl} />;
}
